import React, { useEffect, useState } from "react";
import { navigation } from "../Data/data.js";
import { GrInfo } from "react-icons/gr";
import { BsInstagram, BsGithub, BsLinkedin } from "react-icons/bs";
const Navbar = () => {
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    function scrollActive() {
      setScroll(window.scrollY > 100);
    }
    window.addEventListener("scroll", scrollActive);
    return () => window.removeEventListener("scroll", scrollActive);
  });
  const [social, setSocial] = useState(false);
  const [toggle, setToggle] = useState(false);
  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 ${
        scroll ? `bg-[rgba(55,155,255,0.85)]` : `bg-blue-500`
      } shadow-md shadow-blue-800`}
    >
      <div className="max-w-full px-3 lg:px-0 lg:max-w-[80vw] flex items-center pt-6 my-4 justify-between mx-auto">
        <div className="left text-3xl text-white">
          <div className="image">{/* logo */}</div>
          Saquib
        </div>
        <div
          className={`duration-[1.4s] rounded-r-3xl ease-in-out items-center justify-end flex-col md:flex-row flex fixed  w-full ${
            !toggle
              ? `left-[-100%] top-0 bottom-0`
              : `left-[-15%] top-0 bottom-0`
          } md:bg-inherit bg-blue-400 opacity-[0.95] md:static text-3xl md:text-2xl lg:text-2xl`}
        >
          {navigation.map((items) => {
            return (
              <a
                key={items.name}
                href={items.href}
                className="hover:uppercase hover:cursor-pointer text-white hover:text-blue-500 hover:bg-white duration-500 ease-in-out mx-1 rounded-xl py-0 md:py-2"
                onClick={() => {
                  setToggle(false);
                }}
              >
                <p className="  duration-300 list-none mx-5 my-10 pb-10 md:pb-0 md:my-auto border-b-8 md:border-none border-sky-200">
                  <span className="text-red-400">{`</>`}</span>
                  {items.name}
                </p>
              </a>
            );
          })}
          <div
            className={`hover:cursor-pointer text-lg lg:right-10 right-0 top-[-40%] lg:top-2 hidden md:block absolute h-12 lg:h-10 w-9 rounded-none lg:pt-0 pt-2 lg:rounded-full mt-10 ${
              !social ? `animate-pulse` : `animate-none`
            } hover:animate-none  bg-white`}
          >
            <GrInfo
              className="text-4xl text-center py-1 pt-2"
              onClick={() => {
                setSocial(!social);
              }}
            />
            {social && (
              <div className="text-white lg:py-2 py-[0.15rem] rounded-none pt-4 -mt-[0.99rem] lg:mt-1 bg-[rgba(96,165,250,0.5)] flex flex-row fixed lg:static top-2 right-9 lg:flex-col  items-center justify-evenly lg:rounded-full">
                <a
                  className="py-1 mt-0 lg:mt-2 text-2xl hover:animate-pulse"
                  href="https://www.instagram.com/kooky._.cookie/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsInstagram />
                </a>
                <a
                  className="py-1 text-2xl hover:animate-pulse"
                  href="https://github.com/Saquib1973"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsGithub />
                </a>
                <a
                  className="py-1 text-2xl hover:animate-pulse"
                  href="https://www.linkedin.com/in/saquib-ali-4a3235219/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsLinkedin />
                </a>
              </div>
            )}
          </div>
          <div
            className="block md:hidden absolute right-3 top-14 w-[2rem]"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <div
              className={`flex flex-col ${
                !toggle ? `hidden` : `block`
              } items-center justify-around`}
            >
              <div className="w-[2rem] bg-white h-[5px] rotate-[50deg]  absolute"></div>
              <div className="w-[2rem] bg-white h-[5px] rotate-[130deg] absolute"></div>
            </div>
          </div>
        </div>
        <div
          className="block md:hidden absolute right-5 sm:right-10 top-10 "
          onClick={() => {
            setToggle(!toggle);
          }}
        >
          <div
            className={`flex ${
              toggle ? `hidden` : `block`
            } flex-col h-[2rem] justify-around items-center`}
          >
            <div className="h-[5px] bg-white w-[2rem]"></div>
            <div className="h-[5px] bg-white w-[2rem]"></div>
            <div className="h-[5px] bg-white w-[2rem]"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
